import React, { FC } from 'react';
import injectSheet from 'react-jss';
import Tooltip from 'HOC/Tooltip';
import CogIcon from 'Assets/ui/cog.svg';
import styleSheet from './styles';
import { Loading } from '../../components/Loading';

interface Props {
  img?: any;
  title?: string;
  showCogIcon?: any;
  cardConfig?: any;
  configMenu?: boolean;
  showConfigMenu?: any;
  classes: any;
  loading?: any;
  error?: any;
  onClick?: (e: any) => void;
  onMouseEnter?: (e: any) => void;
  onMouseLeave?: (e: any) => void;

  // group the overriding styles to avoid polluting the card props
  // eslint-disable-next-line react/no-unused-prop-types
  overrideStyles?: {
    width?: string;
    height?: string;
    cursor?: string;
    paddingTop?: string;
    paddingRight?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    boxShadow?: string;
    hoverBoxShadow?: string;
    h2MarginBottom?: string;
    borderRadius?: string;
  };
  children?: any;
}

const Card: FC<Props> = (props: Props) => {
  const {
    img,
    title,
    showCogIcon,
    cardConfig,
    configMenu,
    showConfigMenu,
    classes,
    loading,
    error,
    onClick,
    onMouseEnter,
    onMouseLeave,
    children,
  } = props;

  return (
    <div
      id={classes.id}
      className={classes.card}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyUp={(e: any) => {
        if (e.keycode === 13) {
          onClick(e);
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className={classes.wrapper}>
        {img ? (
          <div className={classes.center}>
            <div className={classes.iconHolder}>
              {React.createElement(img, {})}
            </div>
            {title && <h2>{title}</h2>}
          </div>
        ) : (
          <>{title && <h2>{title}</h2>}</>
        )}
        <span style={{ position: 'relative' }}>
          {!error && !loading && showCogIcon && (
            <span
              style={{
                position: 'relative',
                top: '9px',
                float: 'right',
                cursor: 'pointer',
              }}
            >
              <Tooltip
                position="top"
                text="Field Configuration"
                offsetTop={-40}
                offsetLeft={-62}
              >
                <button
                  aria-label="Field Configuration"
                  className={classes.cogIcon}
                  onClick={() => {
                    showConfigMenu(!configMenu);
                  }}
                  type="button"
                >
                  <CogIcon />
                </button>
              </Tooltip>
            </span>
          )}
          {configMenu && cardConfig}
        </span>
        {loading && <Loading />}
        {error && <div>{error}</div>}
        {!error && !loading && children}
      </div>
    </div>
  );
};

Card.defaultProps = {
  img: undefined,
  title: '',
  showCogIcon: false,
  cardConfig: {},
  configMenu: false,
  showConfigMenu: false,
  loading: undefined,
  error: undefined,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  overrideStyles: {},
  children: undefined,
};

export default injectSheet(styleSheet)(Card);
